import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Form, Dropdown, Button } from 'react-bootstrap';
import store from 'features/store';
import './Accordion.scss';
import { closeicon, openSearchIcon, searchIcon } from 'shared/assets/icons';

export const SearchAccordion = ({ props, asDropdown = false }) => {
    const user = useSelector(state => state.user);
    const reduxState = useSelector(state => state);
    const [searchValue, setSearchValue] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);
    const toggleDropdown = () => setShowDropdown(prev => !prev);
    const closeDropdown = () => setShowDropdown(false);

    useEffect(()=>{
        setSearchValue('')
    },[ props.location.pathname])

    const viewMoreItems = (event) => {
        event.preventDefault();

        if (searchValue) {
            const path = props.location.pathname;
            const newPath = `/view-more-items/${searchValue}`;

            if (path.includes('view-more-items') && path.split('/')[2] === searchValue) {
                store.dispatch({ type: 'UPDATE_NLP_SEARCH', payload: !reduxState.nlpSearch });
            } else {
                if (path.includes('/view-more-items')) {
                    props.history.replace({ pathname: newPath, searchValue });
                } else {
                    props.history.push({ pathname: newPath, searchValue });
                }
            }

            if (asDropdown) closeDropdown();
        }
    };

    return (
        <div className='accordion-box'>
            {
                asDropdown ?
                    <Dropdown className="quick-link" show={showDropdown} onToggle={setShowDropdown}>
                        <Dropdown.Toggle
                            id="quickLinks"
                            style={{ border: 'none' }}
                            onClick={toggleDropdown} >
                            {!showDropdown ? searchIcon : openSearchIcon}
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="shadow">
                            <Dropdown.Item
                                className='menu-box'
                                onClick={(e) => e.stopPropagation()}
                                style={{ backgroundColor: 'white', borderTop: 'none' }} >
                                <Form className='search-box-form w-100' onSubmit={viewMoreItems}>
                                    <div className="search-box w-100">
                                        <div className="input-group w-100" style={{ marginTop: '3px' }}>
                                            <span className="d-flex input-group-append align-items-center clickable">
                                                <i className="fa fa-search"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control  custom-search-placeholder py-2"
                                                id="advance-sale-search-input"
                                                aria-label='Search unique treasures...'
                                                placeholder="Search unique treasures..."
                                                value={searchValue}
                                                onChange={(e) => setSearchValue(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </Form>
                                <div className="buttons d-flex w-100 p-3">
                                    <Button variant="outline-primary w-50" style={{color: '#00263E', backgroundColor: '#868E961A', borderColor:'#868E961A'}} onClick={closeDropdown}>Cancel</Button>
                                    <Button variant="secondary w-50 ml-10" onClick={viewMoreItems}>Search</Button>
                                </div>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    :
                    <div className="inline-search-box">
                        <Form onSubmit={viewMoreItems}>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search..."
                                    value={searchValue}
                                    onChange={(e) => setSearchValue(e.target.value)}
                                />
                                <Button type="submit" variant="primary">Search</Button>
                            </div>
                        </Form>
                    </div>
            }
        </div>
    );
};
